"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolloutService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class RolloutService {
    /**
     * @returns RolloutInclusionResponse Ok
     * @throws ApiError
     */
    static getOnboardingRolloutInclusion() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v1/rollout/onboarding',
        });
    }
    /**
     * @returns ExperimentsResponse Ok
     * @throws ApiError
     */
    static getExperiments() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v1/rollout/experiments',
        });
    }
}
exports.RolloutService = RolloutService;
